module.exports = __webpack_public_path__ + "img/home-setting-ware-2.7e2c5c65.png";